module.exports = __webpack_public_path__ + "img/banner.5c130462.png";